import { FormControl, type ControlValueAccessor } from '@angular/forms';

/**
 * A generic base class to abstract the `ControlValueAccessor` interface. Override any methods if needed.
 *
 * Use the `formControl` property as control instance to bind in the template: `[formControl]="formControl"`
 */
export class BaseControlValueAccessor<T> implements ControlValueAccessor {
    public disabled = false;
    public formControl = new FormControl<T | null | undefined>(undefined);

    public propagateChange?: (value: T | undefined) => void;
    public propagateTouch?: () => void;

    public writeValue(value: T | null | undefined): void {
        this.formControl.setValue(value ?? undefined);
    }

    public onChange(value: T | null | undefined): void {
        if (value !== undefined) {
            this.propagateTouch?.();
        }
        this.propagateChange?.(value ?? undefined);
    }

    public registerOnChange(fn: (value: T | undefined) => void): void {
        this.propagateChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.propagateTouch = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;

        if (isDisabled) {
            this.formControl.disable();
        } else {
            this.formControl.enable();
        }
    }
}
